import type { LiteClassesItems } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

export const getQueryKey = (id: string) => ["getLiteClassesBySession", id];

interface Args<TData = LiteClassesItems> {
  id: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<LiteClassesItems, Error, TData>>;
}

export const useGetClassesLiteBySession = <TData = LiteClassesItems>({
  id: session_id,
  useQueryOptions,
}: Args<TData>) => {
  const getClassesLite = async (): Promise<LiteClassesItems> => {
    return await learningServiceRequest({
      method: "get",
      url: `/classes/lite/related-to-session/${unref(session_id)}`,
    }).then((response) => response?.data?.data);
  };

  return useQuery<LiteClassesItems, Error, TData>({
    queryKey: computed(() => getQueryKey(unref(session_id))),
    queryFn: getClassesLite,
    ...useQueryOptions,
  });
};
